/**
 * [ File :: B_ProtonParticle.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/animate/proton/B_ProtonParticle.js
 * @목적 : Proton 애니메이션 명세
 * @진행 : 개발종료 (필요시 추가)
 * @주의 : ProtonJS 이해가 선행
 * @이슈 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 : https://a-jie.github.io/Proton/
 */

import B_Proton from 'canvas/base/dev/animate/proton/B_Proton';
import B_Define from 'canvas/base/dev/util/B_Define';

const B_ProtonParticle = (function () {

	return class extends B_Proton {

		constructor(canvas) {
			super(canvas);
		}

		// [F] public

		/**
		 * [ Function :: smoke ]
		 *
		 * @DES :: 연기 - 입자 애니메이션 (proton)
		 * @IP1 :: stage {obj} - 무대
		 * @IP2 :: x {num}
		 * @IP3 :: y {num}
		 * @IP4 :: dis {num}
		 * @IP5 :: arrColor {arr}
		 * @O.P :: emitter{obj} - 시작/정지
		 * @S.E :: protonJS 참조
		 */
		smoke(stage, x, y, dis, arrColor) {

			let proton = new Proton, renderer, emitter;

			// # Emitter 객체 생성 및 설정
			emitter = new Proton.Emitter();
			emitter.rate = new Proton.Rate(
				new Proton.Span(0, 1),  // 파편 갯수 관련
				new Proton.Span(.1, .2) //
			);

			// addInitialize
			emitter.addInitialize(new Proton.Mass(0.1));                  // mass
			// emitter.addInitialize(new Proton.Radius(2, 2));            // 파편 크기
			emitter.addInitialize(new Proton.Radius(dis / 30, dis / 20)); // 파편 크기 (그리드 크기에 비례)
			emitter.addInitialize(new Proton.Life(1, 10));                // 지속 능력 (min~max)
			emitter.addInitialize(new Proton.V(
				new Proton.Span(0.5/*min*/, 0.5/*max*/),     // speed
				new Proton.Span(-30, 30),                    // rotate
				'polar')
			);

			// addBehaviour
			emitter.addBehaviour(new Proton.Alpha(1, 0));   // Alpha
			emitter.addBehaviour(new Proton.Scale(1, 0));   // Scale
			emitter.addBehaviour(new Proton.Color(          // Color
				arrColor
				, 'random'));

			emitter.addBehaviour(new Proton.CrossZone(
				new Proton.CircleZone(
					x /*원을 만드는데 사용*/,  // => 스프레이처럼 이용가능
					y /*원을 만드는데 사용*/,  // => 스프레이처럼 이용가능
					dis / 2 /*확장 범위 radius*/),
				'dead')
			);

			// # 발산자 중심 위치
			emitter.p.x = x;
			emitter.p.y = y;

			emitter.emit();
			proton.addEmitter(emitter);

			// # renderer 설정
			renderer = new Proton.Renderer('easel', proton, stage);
			renderer.start();       // 랜더링 시작

			// # proton arr
			this.getArrProton().push(proton);

			// # garbage collection을 위한 active 객체
			proton.active = true;

			function tick() {
				if (proton.active) {
					proton.update();
					requestAnimationFrame(tick);
				}
			}

			tick();

			return emitter;
		}

		/**
		 * [ Function :: firework ]
		 *
		 * @DES :: 폭죽 - 입자 애니메이션 (proton)
		 * @IP1 :: stage {obj} - 무대
		 * @IP2 :: x {num} - X 좌표
		 * @IP3 :: y {num} - Y 좌표
		 * @IP4 :: dis {num} - 그리드 크기
		 * @IP5 :: attr {json} - 속성모음
		 * @O.P :: emitter{obj} - 시작/정지
		 * @S.E :: protonJS 참조
		 */
		firework(stage, x, y, dis, attr) {
			// /*[T]*/ console.log(stage, x, y, dis, attr);

			let proton = new Proton, renderer, emitter;

			emitter = new Proton.Emitter();
			emitter.rate = new Proton.Rate(
				new Proton.Span(attr.count[0], attr.count[1]),  // 파편 갯수 관련
				new Proton.Span(.1, .2)                         //
			);

			// addInitialize
			emitter.addInitialize(new Proton.Mass(0.1));                            // mass
			// emitter.addInitialize(new Proton.Radius(attr.size[0], attr.size[1]));// 파편 크기
			emitter.addInitialize(new Proton.Radius(dis / 30, dis / 20));           // 파편 크기 (그리드 크기에 비례)
			emitter.addInitialize(new Proton.Life(1, 10));                          // 지속 능력 (min~max)
			emitter.addInitialize(new Proton.V(
				new Proton.Span(attr.speed[0] / 1000/*min*/, attr.speed[1] / 1000/*max*/),     // speed
				new Proton.Span(0, 360),                                                       // rotate
				'polar')
			);

			// addBehaviour
			emitter.addBehaviour(new Proton.Alpha(1, 0));   // Alpha
			emitter.addBehaviour(new Proton.Scale(1, 0));   // Scale
			emitter.addBehaviour(new Proton.Color(          // Color
				attr.color ? attr.color : ['black'], 'random'));
			emitter.addBehaviour(new Proton.CrossZone(
				new Proton.CircleZone(
					x /*원을 만드는데 사용*/,  // => 스프레이처럼 이용가능
					y  /*원을 만드는데 사용*/,  // => 스프레이처럼 이용가능
					dis / 2 /*확장 범위 radius*/),
				'dead')
			);

			// # 발산자 중심 위치
			emitter.p.x = x;
			emitter.p.y = y;

			emitter.emit();
			proton.addEmitter(emitter);

			renderer = new Proton.Renderer('easel', proton, stage);
			renderer.blendFunc("SRB_ALPHA", "ONE");
			renderer.start();

			// # proton arr
			this.getArrProton().push(proton);

			// # STOP TRIGGER (시간후에 파편 발산 중지 및 Proton.emitters 배열에서 제거)
			setTimeout(() => {
				emitter.stopEmit();
			}, B_Define.INTERVAL * attr.time);

			// # garbage collection을 위한 active 객체
			proton.active = true;

			function tick() {
				if (proton.active) {
					proton.update();
					requestAnimationFrame(tick);
				}
			}
			tick();

			return emitter;
		}

	}
}());

export default B_ProtonParticle;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/animate/proton/B_ProtonParticle.js